<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup change user
 * @created at      :   2022/07/23
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import { mapMutations, mapState } from 'vuex';
import repository from '@/utils/repository';
import store from '@/store';
/**
 * Import template
 */
import template from './template.html';
import './style.scss';

/**
 * Define component chat for show page chat
 */
var PopupChangeUser = {
    template: template,
    props: {
        modelValue: Boolean,
        onSelected: Function
    },
    emits: ['update:modelValue'],
    data() {
        return {
            company: {},
            users: [],
            paging: {},
            condition: {
                search: '',
                filterId: '0',
                includeOldEmp: '0'
            }
        };
    },
    computed: {
        ...mapState('app', ['user']),
        showModal: {
            get() {
                return this.modelValue;
            },
            set() {}
        }
    },
    mounted() {
        setTimeout(() => {
            this.$refs.inputSearch?.focus();
        }, 500);
    },
    methods: {
        ...mapMutations('app', ['hideHeaderError']),
        close() {
            this.$emit('update:modelValue', false);
            this.hideHeaderError();
        },
        onShow() {
            this.getCompany();
            this.hideHeaderError();
        },
        onHide() {
            this.condition = {
                search: '',
                filterId: '0',
                includeOldEmp: '0'
            };
        },
        getCompany() {
            repository.get(`/cm/cm0020i/0`).then((res) => {
                const { data } = res;
                if (data.Code === 200) {
                    this.company = data.Data;
                } else {
                    this.company = {};
                }
            });
        },
        searchUsers(page) {
            this.paging.page = page ?? 1;
            repository
                .get(`/common/search/users`, {
                    params: {
                        p002: this.condition.search,
                        p003: this.condition.filterId,
                        p005: this.condition.includeOldEmp,
                        p006: this.paging.page ?? 1
                    }
                })
                .then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        this.users = data.Data.users;
                        this.paging = data.Data.paging;
                    } else {
                        this.users = [];
                        this.paging = {};
                    }
                });
        },
        selectRow(item) {
            let switchUser = sessionStorage.getItem('switchUser');
            if (!switchUser) {
                switchUser = item;
            } else {
                // eslint-disable-next-line no-undef
                switchUser = JSON.parse(Base64.decode(switchUser));
                switchUser = {
                    ...switchUser,
                    ...item
                };
            }
            this.user.switchUser = switchUser;
            sessionStorage.setItem(
                'switchUser',
                // eslint-disable-next-line no-undef
                Base64.encode(JSON.stringify(switchUser))
            );
            store.dispatch('app/getAppState', null, { root: true });
            if (this.onSelected) {
                this.onSelected(item);
            }
            this.$router.push({
                name: 'Gs0510v'
            });
            store.dispatch('gs0510v/getData', 0);
            this.close();
        },
        resetUser() {
            this.user.switchUser = null;
            sessionStorage.removeItem('switchUser');
            this.close();
            store.dispatch('app/getAppState', null, { root: true });
            this.$router.push({
                name: 'Gs0510v'
            });
        }
    }
};
export default PopupChangeUser;
</script>
